import PropTypes from 'prop-types';
import React from 'react';
export default function MinusSmall(_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, height: "2", viewBox: "0 0 10 2", width: "10" },
        React.createElement("path", { d: "M1,0H9a1,1,0,0,1,1,1h0A1,1,0,0,1,9,2H1A1,1,0,0,1,0,1H0A1,1,0,0,1,1,0Z" })));
}
MinusSmall.propTypes = {
    className: PropTypes.string,
};
MinusSmall.defaultProps = {
    className: 'display-block',
};
